/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMap: {
  name: 'map';
  data: string;
} = {
  name: 'map',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.28.586A.5.5 0 0 1 15.5 1v11a.5.5 0 0 1-.243.429l-4.993 2.995A.497.497 0 0 1 10 15.5h-.017a.497.497 0 0 1-.247-.075L5.03 12.601 1.3 15.4a.5.5 0 0 1-.8-.4V3a.5.5 0 0 1 .276-.447L4.767.557a.498.498 0 0 1 .43-.017L10 2.461 14.814.536a.5.5 0 0 1 .466.05Zm-.78 11.13-4 2.4V3.34l4-1.6v9.978Zm-9-9.977 4 1.6v10.778l-4-2.4V1.739Zm-1 .07-3 1.5V14l3-2.25V1.809Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
